import i18n from "../i18n";

import { JSX, ReactNode, useEffect, useState } from "react";

import { LocalizationProvider } from "@plansoft-configuration-renderer/components";
import { TranslationNamespace } from "@plansoft-configuration-renderer/localization";

const CONFIGURATOR_BASE_URL = "/preview";

const UI_CONTEXTS = [
  TranslationNamespace.ConfigurationRenderer,
  TranslationNamespace.CustomApp,
];

export function UiTranslationsProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  // Subscribe to the global i18next singleton directly instead of via
  // react-i18next's `useTranslation()` — that hook's re-render subscription
  // is keyed to actually consuming a namespace, and this instance has none
  // (see src/i18n.ts), so relying on it here was unreliable: switching the
  // language never re-rendered this provider, so `LocalizationProvider` kept
  // fetching/serving the app's startup locale no matter what was selected.
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    i18n.on("languageChanged", setLanguage);
    return () => {
      i18n.off("languageChanged", setLanguage);
    };
  }, []);

  const configurationLocale = language === "cimode" ? "en-US" : language;

  return (
    <LocalizationProvider
      configurationLocale={configurationLocale}
      uiContexts={UI_CONTEXTS}
      configuratorBasePath={CONFIGURATOR_BASE_URL}
    >
      {children}
    </LocalizationProvider>
  );
}
